import { Link, graphql } from 'gatsby';
import React, { FC } from 'react';

const Examples: FC<{ data: Queries.ExamplesQuery }> = ({ data }) => {
  const nodes = data.allSitePage.nodes.concat();

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold">Examples</h1>
      <ul>
        {nodes
          .sort((a, b) => (a.path > b.path ? 1 : -1))
          .map((node) => (
            <li key={node.path}>
              <Link to={node.path}>{node.path}</Link>
            </li>
          ))}
      </ul>
    </div>
  );
};

export default Examples;

export const query = graphql`
  query Examples {
    allSitePage(filter: { path: { regex: "//example//" } }) {
      nodes {
        path
      }
    }
  }
`;
